import { render, staticRenderFns } from "./QualityPapers.vue?vue&type=template&id=1eeb0d02&scoped=true&"
import script from "./QualityPapers.vue?vue&type=script&lang=js&"
export * from "./QualityPapers.vue?vue&type=script&lang=js&"
import style0 from "./QualityPapers.vue?vue&type=style&index=0&id=1eeb0d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb0d02",
  null
  
)

export default component.exports